import _ from 'lodash';
import {Table, TableBody, TableCell, TableHead, TableRow} from '@material-ui/core';
import {Store} from '@treez/commons/sharedTypings/directory';
import React, {FunctionComponent} from 'react';
import {ProductInCatalog} from '@treez/commons/sharedTypings/product';
import {tableFields} from '../CatalogAssignment';
import ProductInfoRow from './ProductInfoRow';

const TABLE_WIDTH_THRESHOLD = 2;

enum TableFieldOptions {
    AMOUNT = 'amount',
    BRAND = 'brand',
    PRODUCT = 'product',
    SKU = 'sku',
}

const PRODUCT_TABLE_FIELDS = [
    TableFieldOptions.SKU,
    TableFieldOptions.PRODUCT,
    TableFieldOptions.BRAND,
    TableFieldOptions.AMOUNT,
];

interface Props {
    stores: Store[];
    productToMergeTo: Partial<ProductInCatalog>;
    productsToMerge: Partial<ProductInCatalog>[];
}

export const MergeProductInfoTable: FunctionComponent<Props> = (props: Props) => {
    const {stores, productToMergeTo, productsToMerge} = props;

    const numberOfValidStores = stores.length;

    let tableClass = 'product-table-matrix-view';
    if (numberOfValidStores > TABLE_WIDTH_THRESHOLD) {
        tableClass += ' adjusted';
    }

    return (
        <div className={tableClass}>
            <Table>
                <TableHead>
                    <TableRow>
                        {_.map(PRODUCT_TABLE_FIELDS, (field, idx) => {
                            const headerAttributes = tableFields[field];

                            const {displayName} = headerAttributes;

                            return (
                                <TableCell
                                    className="catalog-assignment-table-header"
                                    key={field + idx}
                                >
                                    {displayName}
                                </TableCell>
                            );
                        })}
                    </TableRow>
                </TableHead>
                <TableBody>
                    <ProductInfoRow
                        productToRender={productToMergeTo}
                        key="merged-product-product-info"
                    />
                    <TableRow
                        className="original-products-label-table-rows"
                        key="product-info-original-products-label"
                    >
                        <TableCell colSpan={PRODUCT_TABLE_FIELDS.length}>
                            Original Products
                        </TableCell>
                    </TableRow>
                    {_.map(productsToMerge, (product, idx) => {
                        return (
                            <ProductInfoRow
                                productToRender={product}
                                key={`${product.id}-${idx}-product-info`}
                            />
                        );
                    })}
                </TableBody>
            </Table>
        </div>
    );
};
